import { Box } from '@mui/system';
import { Controller, useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputField } from 'src/components/atoms/input-field';
import { LoadingButton } from 'src/components/atoms/loading-button/loading-button';
import { useKeyDown } from 'src/hooks/use-key-down';
import { Logo } from 'src/icons/logo';
import { EmailStepFormValues } from '../../../schema/use-form-validation-schema';
import AuthFormWrapper from '../../templates/auth-form-wrapper';
import AuthFormHeader from '../auth-form-header';

interface Props {
  onSubmit: (values: EmailStepFormValues) => Promise<void>;
}

export const EmailStep = ({ onSubmit }: Props) => {
  const { control, handleSubmit } = useFormContext<EmailStepFormValues>();
  const { isValid, isSubmitting } = useFormState<EmailStepFormValues>();

  const { t } = useTranslation();

  useKeyDown('Enter', handleSubmit(onSubmit));

  return (
    <AuthFormWrapper
      actionsSlot={
        <LoadingButton
          variant="contained"
          size="medium"
          disabled={!isValid}
          loading={isSubmitting}
          onClick={handleSubmit(onSubmit)}>
          {t('auth:login.submitButton')}
        </LoadingButton>
      }>
      <AuthFormHeader
        title={t('auth:login.title')}
        description={t('auth:login.contentEmail')}
        icon={<Logo />}
      />
      <Box>
        <Controller
          name="email"
          control={control}
          render={({
            field: { onChange, onBlur, value, ref },
            fieldState: { error },
          }) => (
            <InputField
              label={t('auth:email')}
              fullWidth
              required
              inputRef={ref}
              onBlur={onBlur}
              onChange={onChange}
              type="email"
              value={value}
              autoComplete="email"
              error={!!error}
              helperText={error?.message}
              sx={{ my: 1 }}
            />
          )}
        />
      </Box>
    </AuthFormWrapper>
  );
};
